import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('dollhouseselect', {
        template: require('./doll-house-select-demo.html'),
        controller: DollHouseSelectDemoCtrl,
        controllerAs: 'vm'
    });

    DollHouseSelectDemoCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function DollHouseSelectDemoCtrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {
        var vm = this;

        vm.version = UTILS.version;
        
        $rootScope.title = 'Dollhouse';

        vm.data = {};
        vm.id = $stateParams.id;

        get_details();
        function get_details() {

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/demo_class/`+vm.id+'/doll_house',
            };

            QueryService.query(request)
                .then(
                    function(response) {

                        vm.data = response.data.data.items[0];

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        };

        vm.choose = () => {
            var request = {
                method: 'PUT',
                route: URLS.base + `/demo_class/`+vm.id+'/doll_house',
            };

            QueryService.query(request)
                .then(
                    function(response) {

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
            
        }
        vm.choose();

        vm.go_back = function(){
            $location.path('/demo');
        }
    }
})();


// WEBPACK FOOTER //
// ./src/app/components/doll-house/select_demo_class/doll-house-select-demo.component.js